<template>
  <p
    v-if="typeCountdown == 'lotto'"
    class="text-h6"
    :class="textPosition"
  >
    {{ formattedTimeLeft }}
  </p>
  <p
    v-else
    class="text-h4"
    :class="textPosition"
  >
    {{ formattedTimeLeft }}
  </p>
</template>
<script>
const SECOND = 1;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default {
  name: 'Countdown',
  props: {
    secondsLeft: { type: Number, default: 0 },
    textPosition: { type: String, default: 'text-center py-0 my-0' },
    typeCountdown: { type: String, default: '' },
  },
  data() {
    return {
      totalSeconds: this.secondsLeft,
      timerInterval: null,
    };
  },

  computed: {
    formattedTimeLeft() {
      return this.totalSeconds > 0
        ? `${Math.floor(this.totalSeconds / HOUR)
          .toString()
          .padStart(2, '0')
        }:${
          Math.floor((this.totalSeconds % HOUR) / MINUTE)
            .toString()
            .padStart(2, '0')
        }:${
          Math.floor((this.totalSeconds % MINUTE) / SECOND)
            .toString()
            .padStart(2, '0')}`
        : this.typeCountdown == 'lotto'
          ? 'จบเกมส์'
          : 'หมดเวลา';
    },
  },

  watch: {
    formattedTimeLeft(val) {
      if (this.totalSeconds <= 0) {
        this.onTimesUp();
      }
    },
  },
  mounted() {
    this.startCountdown();
  },

  methods: {
    onTimesUp() {
      this.$emit('game-timeout');
      clearInterval(this.timerInterval);
      // window.location.reload();
    },
    startCountdown() {
      this.totalSeconds = this.secondsLeft;
      this.timerInterval = setInterval(() => (this.totalSeconds -= 1), 1000);
    },
  },
};
</script>
